<template>
  <form  @submit.prevent="searchSubmit()" :class="{ 'card shadow-sm mb-4': ! isMachupicchu, 'mp__banner__container': isMachupicchu }">
    <div class="card-body">
      <div :class="{ 'row': ! isMachupicchu, 'row align-items-center': isMachupicchu }">
        <div class="col" :class="{ 'mb-2': ! isMachupicchu }">
          <input v-model="search" type="text" class="form-control" :placeholder="isMachupicchu ? '¿Qué estas buscando?' : placeholder" />
        </div>
        <div class="col-12" :class="{ 'col-md-3': ! isMachupicchu, 'col-md-2': isMachupicchu }">
          <button type="submit" class="btn btn-primary btn-block">Buscar</button>
        </div>
        <div v-if="isMachupicchu" class="col-12 col-md-1">
          <div class="notifications__container d-flex align-items-center justify-content-center">
            <div v-if="notifications.length" class="notifications__count d-flex align-items-center justify-content-center">
              {{ notifications.length }}
            </div>
            <Notifications />
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { Notifications } from '../assets/icons';
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Nombre del evento',
    },
    isMachupicchu: {
      type: Boolean,
      default: false,
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    console: () => console
  },
  components: { Notifications },
  data() {
    return {
      search: ''
    };
  },
  methods: {
    searchSubmit() {
      this.$emit('submit', this.search);
      if (this.search.length === 13 && !Number.isNaN(parseInt(this.search, 0))) {
        this.search = '';
      }
    }
  }
};
</script>
